export default {
  eventCloseds: [],
  eventClosed: {},
  name: '',
  place: '',
  year: '',
  month: '',
  date: '',
  day: '',
  startHour: 0,
  startMinute: 0,
  finishHour: 1,
  finishMinute: 0,
  closeTime: 0,
  content: '',
  quizset: ''
}
